<template>
  <div>
    <DataTable
      ref="DataTable"
      :data-model="'products/doctorSection'"
      :display-name-plural="$t('entities.ProductDoctorSection.Plural')"
      :display-name-singular="$t('entities.ProductDoctorSection.Singular')"
      :permission-name="'Products'"
      :allow-delete="false"
      :allow-create="false"
      :exclude-fields="['id', 'isInvalid', 'isInProgress']"
      @loading-finished="onDataTableLoadingFinished()"
      @input="onDataTableInput">
      <template #cell(status)="row">
        {{ $t('products.Status.'+row.item.status) }}
      </template>
      <template #cell(color)="row">
        <div :style="'min-height:15px;background-color:'+(colors.filter(x => x.id == row.item.color)[0].value)"
             v-if="row.item.color !== 0" />
      </template>
      <template #cell(approvedByLaboratory)="row">
        <b-form-checkbox v-model="row.item.approvedByLaboratory"
                         @change="productToApproveItem = row.item;"
                         :disabled="!isApproveByLaboratoryAuthorized" />
      </template>
      <template #cell(pairedPhenotypesCount)="row">
        <div :class="row.item.isInvalid ? 'invalid-product-count': ''">
          {{ row.item.pairedPhenotypesCount }}
        </div>
      </template>
      <template #extraTableActions>
        <v-alert
          color="#17A2B8"
          v-if="productBuildingInProgress">
          <font-awesome-icon class="fa-md"
                             icon="cogs" />
          {{ $t('common.BuildingProductInProgress') }}
        </v-alert>
      </template>
      <template #extraActions="row">
        <el-tooltip
          :content="$t('common.DownloadPDF')"
          :enterable="false"
          placement="top">
          <b-button class="downloadBtn mx-1"
                    @click="download(row.item)">
            <font-awesome-icon class="fa-xs"
                               icon="download" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.DownloadDoctorsIntroPDF')"
          :enterable="false"
          placement="top">
          <b-button class="downloadBtnDoctor mx-1"
                    @click="downloadDoctorsIntro(row.item)">
            <font-awesome-icon class="fa-xs"
                               icon="file-download" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.AssignDoctorToProduct')"
          :enterable="false"
          placement="top"
          v-if="isMainDoctor">
          <b-button class="assignBtnDoctor mx-1"
                    @click="productToAssign = row.item.id; $refs.assignModal.show();">
            <font-awesome-icon class="fa-md"
                               icon="briefcase-medical" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.DownloadProcessProductReport')"
          :enterable="false"
          placement="top">
          <b-button class="downloadBtnProcessProductReport mx-1"
                    @click="downloadProcessProductReport(row.item)">
            <font-awesome-icon class="fa-md"
                               icon="tasks" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.MoveFromDoctorSection')"
          :enterable="false"
          placement="top">
          <b-button class="moveProductToResultsBtn mx-1"
                    @click="toMoveToResults = row.item; $refs.moveToResultsModal.show();"
                    :disabled="actionDisabled(row)">
            <font-awesome-icon class="fa-md"
                               icon="step-backward" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.MoveToArchive')"
          :enterable="false"
          placement="top">
          <b-button class="moveProductToArchiveBtn mx-1"
                    @click="toMoveToArchive = row.item; $refs.moveToArchiveModal.show();"
                    :disabled="actionDisabled(row)">
            <font-awesome-icon class="fa-md"
                               icon="archive" />
          </b-button>
        </el-tooltip>
      </template>
    </DataTable>
    <b-modal id="modal-center"
             ref="downloadModal"
             centered
             :ok-disabled="true"
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.Downloading') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t(downloadModalMessageKey) }}
      </p>
      <div id="nprogressDownload"
           style="height:25px" />
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="cancelDownload(); $refs.downloadModal.hide()">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="assignModal"
             centered
             :ok-disabled="true"
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.AssignDoctorToProduct') }}
          </h3>
        </div>
      </template>
      <DoctorInput v-model="doctorToAssign" />
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="doctorToAssign = 0; productToAssign = 0; $refs.assignModal.hide()">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="success"
          @click="assignDoctorToProduct(); $refs.assignModal.hide()">
          {{ $t('common.Edit') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="moveToResultsModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.MoveFromDoctorSection') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.RealyMoveFromDoctorSectionQuestion') }}
      </p>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="toMoveToResults = null; $refs.moveToResultsModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="danger"
          @click="moveProductToResults(toMoveToResults);">
          {{ $t('common.Yes') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="moveToArchiveModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.MoveToArchive') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.RealyMoveToArchiveQuestion') }}
      </p>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="toMoveToArchive = null; $refs.moveToArchiveModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="danger"
          @click="moveProductToArchive(toMoveToArchive);">
          {{ $t('common.Yes') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="reanalyseModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.ReanalyseResults') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.RealyReanalyseResultsQuestion') }}
      </p>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="$refs.reanalyseModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="danger"
          @click="reanalyseResults();">
          {{ $t('common.Reanalyse') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';
import NProgress from 'nprogress/nprogress';
import DoctorColors from '@utils/doctorColors';
import { downloadBlob } from '@utils/downloadBlob';
import DoctorInput from '@components/input/DoctorInput';
import { updatePairedPhenotypesCountMixin } from '@components/mixins/updatePairedPhenotypesCount';

export default {
  components: {
    DataTable,
    DoctorInput
  },
  mixins: [
    updatePairedPhenotypesCountMixin
  ],
  data() {
    return {
      source: null,
      colors: DoctorColors,
      doctorToAssign: 0,
      productToAssign: 0,
      productToApproveItem: null,
      isMainDoctor: false,
      downloadModalMessageKey: 'common.GeneratingPDF',
      toMoveToArchive: null,
      productBuildingInProgress: false,
      lastProductBuildingInProgress: false,
      refreshInterval: null,
      refreshingData: false,
      gettingProductBuildingStatus: false
    };
  },
  computed: {
    approvedByLaboratory() {
      return this.productToApproveItem?.approvedByLaboratory;
    },
    isApproveByLaboratoryAuthorized() {
      return this.isAdmin || this.isLaborant;
    },
    role() {
      return this.$store.state['vue-auth']?.user?.role || '';
    },
    isLaborant() {
      return this.role === 'Laboratory Scientist';
    },
    isAdmin() {
      return this.role === 'Administrator';
    }
  },
  mounted() {
    this.source = this.axios.CancelToken.source();
    this.axios.get('/admin/auth/ismaindoctor')
      .then((res) => {
        this.isMainDoctor = res.data.result;
      });
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
    this.refreshInterval = null;
  },
  watch: {
    approvedByLaboratory(newValue, oldValue) {
      if (oldValue !== undefined) {
        this.approveProduct();
      }
    }
  },
  methods: {
    onButtonClick(row, callback) {
      callback(row.item);
    },
    actionDisabled(row) {
      return row.item.isInProgress;
    },
    cancelDownload() {
      this.source.cancel();
      this.source = this.axios.CancelToken.source();
    },
    download(item) {
      this.showDownloadModal('common.GeneratingPDF');
      NProgress.configure({ parent: '#nprogressDownload' });
      NProgress.start();
      this.axios.get('admin/products/getpdf', {
        params: {
          ProductId: item.id
        },
        responseType: 'arraybuffer',
        cancelToken: this.source.token
      }).then((response) => {
        const today = new Date();
        downloadBlob(
          response.data,
          `GenScan_Vysledek_${today.toLocaleDateString('en-US')} ${item.customer}.pdf`,
          'application/pdf'
        );
        this.hideDownloadModal();
      })
        .catch((thrown) => {
          if (this.axios.isCancel(thrown)) {
            this.$root.$bvToast.toast(this.$t('common.DownloadCancel'), {
              title: this.$t('common.Cancelled'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
            this.hideDownloadModal();
          }
        })
        .finally(() => {
          NProgress.configure({ parent: 'body' });
          NProgress.done();
        });
    },
    downloadDoctorsIntro(item) {
      this.showDownloadModal('common.GeneratingPDF');
      NProgress.configure({ parent: '#nprogressDownload' });
      NProgress.start();
      this.axios.get('admin/products/getdoctorsintropdf', {
        params: {
          ProductId: item.id
        },
        responseType: 'arraybuffer',
        cancelToken: this.source.token
      }).then((response) => {
        const today = new Date();
        downloadBlob(
          response.data,
          `GenScan_Lekarska_Zprava_${today.toLocaleDateString('en-US')} ${item.customer}.pdf`,
          'application/pdf'
        );
        this.hideDownloadModal();
      })
        .catch((thrown) => {
          if (this.axios.isCancel(thrown)) {
            this.$root.$bvToast.toast(this.$t('common.DownloadCancel'), {
              title: this.$t('common.Cancelled'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
            this.hideDownloadModal();
          }
        })
        .finally(() => {
          NProgress.configure({ parent: 'body' });
          NProgress.done();
        });
    },
    downloadProcessProductReport(item) {
      this.showDownloadModal('common.GeneratingProcessProductReport');
      NProgress.configure({ parent: '#nprogressDownload' });
      NProgress.start();
      this.axios.get('admin/products/getprocessproductreport', {
        params: {
          ProductId: item.id
        },
        responseType: 'arraybuffer',
        cancelToken: this.source.token
      }).then((response) => {
        const today = new Date();
        downloadBlob(
          response.data,
          `GenScan_Report_Vytvoreni_Vysledku_${today.toLocaleDateString('en-US')}_${item.customer}.txt`,
          'application/text'
        );
        this.hideDownloadModal();
      })
        .catch((thrown) => {
          if (this.axios.isCancel(thrown)) {
            this.$root.$bvToast.toast(this.$t('common.DownloadCancel'), {
              title: this.$t('common.Cancelled'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
            this.hideDownloadModal();
          }
        })
        .finally(() => {
          NProgress.configure({ parent: 'body' });
          NProgress.done();
        });
    },
    assignDoctorToProduct() {
      this.axios.patch('admin/products/assigndoctor', {
        DoctorId: this.doctorToAssign,
        ProductId: this.productToAssign
      }).then(() => {
        this.$root.$bvToast.toast(this.$t('ViewReservations.SuccessToast.Body'), {
          title: this.$t('ViewReservations.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.doctorToAssign = 0;
        this.productToAssign = 0;
        this.$refs.DataTable.refresh();
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('ViewReservations.FailToast.Body'), {
          title: this.$t('ViewReservations.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });
    },
    approveProduct() {
      this.axios.patch('admin/products/approveByLaboratory', {
        ProductId: this.productToApproveItem.id,
        Approve: this.productToApproveItem.approvedByLaboratory
      }).then(() => {
        this.$root.$bvToast.toast(this.$t('ViewReservations.SuccessToast.Body'), {
          title: this.$t('ViewReservations.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.productToApprove = null;
        this.$refs.DataTable.refresh();
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('ViewReservations.FailToast.Body'), {
          title: this.$t('ViewReservations.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });
    },
    moveProductToResults(item) {
      this.axios.post('admin/products/restore', {
        ProductId: item.id
      }).then(() => {
        this.$root.$bvToast.toast(this.$t('DoctorSection.RemoveFrom.SuccessToast.Body'), {
          title: this.$t('DoctorSection.RemoveFrom.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.$refs.DataTable.removeRowById(item.id);
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('DoctorSection.RemoveFrom.FailToast.Body'), {
          title: this.$t('DoctorSection.RemoveFrom.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      }).finally(() => {
        this.toMoveToResults = null;
        this.$refs.moveToResultsModal.hide();
        NProgress.configure({ parent: 'body' });
        NProgress.done();
      });
    },
    moveProductToArchive(item) {
      this.axios.post('admin/products/moveToArchive', {
        ProductId: item.id
      }).then(() => {
        this.$root.$bvToast.toast(this.$t('Archive.MoveTo.SuccessToast.Body'), {
          title: this.$t('Archive.MoveTo.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.$refs.DataTable.removeRowById(item.id);
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Archive.MoveTo.FailToast.Body'), {
          title: this.$t('Archive.MoveTo.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      }).finally(() => {
        this.toMoveToArchive = null;
        this.$refs.moveToArchiveModal.hide();
        NProgress.configure({ parent: 'body' });
        NProgress.done();
      });
    },
    reanalyseResults() {
      this.axios.post('admin/products/reanalyseAll', {}).then((response) => {
        this.$root.$bvToast.toast(this.$t('ProductResultsReanalysisAll.SuccessToast.Body'), {
          title: this.$t('ProductResultsReanalysisAll.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        if (response.status === 200) {
          this.getProductReanalyseStatus();
          this.$refs.DataTable.reload();
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('ProductResultsReanalysisAll.FailToast.Body'), {
          title: this.$t('ProductResultsReanalysisAll.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      }).finally(() => {
        this.$refs.reanalyseModal.hide();
      });
    },
    getProductBuildingStatus() {
      if (this.gettingProductBuildingStatus) return null;

      this.gettingProductBuildingStatus = true;
      return this.axios.get('admin/products/buildingStatus')
        .then((response) => {
          if (response.status === 200) {
            this.lastProductBuildingInProgress = this.productBuildingInProgress;
            this.productBuildingInProgress = response.data.result.inProgress;
          }
        })
        .finally(() => {
          this.gettingProductBuildingStatus = false;
        });
    },
    checkBuildingStatusAndRefresh() {
      if (this.refreshingData) return;

      const getProductBuildingStatusPromise = this.getProductBuildingStatus();
      if (getProductBuildingStatusPromise !== null) {
        getProductBuildingStatusPromise.then(() => {
          if (this.lastProductBuildingInProgress !== this.productBuildingInProgress
            || this.productBuildingInProgress === true) {
            this.refreshingData = true;
            this.$refs.DataTable.refresh();
          }
        });
      }
    },
    startWatchingProductBuildingStatus() {
      if (this.refreshInterval === null) {
        this.refreshInterval = setInterval(() => {
          this.checkBuildingStatusAndRefresh();
        }, 30 * 1000);
      }
    },
    onDataTableLoadingFinished() {
      this.refreshingData = false;
      this.startWatchingProductBuildingStatus();
    },
    showDownloadModal(messageKey) {
      this.downloadModalMessageKey = messageKey;
      this.$refs.downloadModal.show();
    },
    hideDownloadModal() {
      this.$refs.downloadModal.hide();
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.downloadBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #c95328;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}

.downloadBtnDoctor {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #3e67ec;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}

.assignBtnDoctor {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #3ee6ec;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}

.downloadBtnProcessProductReport {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: rgb(93, 129, 93);
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}

.moveProductToResultsBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: rgb(180, 154, 35);
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}

.moveProductToArchiveBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: rgb(180, 154, 35);
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}

.invalid-product-count {
  color: crimson;
}
</style>
